
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coachingcenter/gifts",
      function () {
        return require("private-next-pages/coachingcenter/gifts.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coachingcenter/gifts"])
      });
    }
  